import {
	GoodCurrency,
	GoodDivider,
	GoodItemContainer,
	GoodList,
	GoodListItem,
	GoodPrice,
	GoodPriceDescription,
	GoodRate,
	PurchasedPlanBadge,
	PurchasedPlanDate,
} from "./GoodItem.styled";
import { observer } from "mobx-react";
import { IconCheck } from "../../../../components/ui/Other/Pricing/Products/icons";
import { useStores } from "../../../../stores";
import { ShopGood } from "../../../../interfaces";
import { API } from "../../../../core";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ButtonBuy } from "./ButtonBuy";
import { getShopGoodAccessState, renderActionShopButton } from "../../../../helpers";
import { ShopGoodStore } from "../../../../stores/shop";

interface GoodItemProps extends ShopGood {
	shopGoodStore: ShopGoodStore;
	btnText?: string;
}

export const GoodItem = observer(
	({ rate = "free", btnText = "Select plan", shopGoodStore, ...props }: GoodItemProps) => {
		const { settingsStore, stripeStore, authStore, promoCodeStore } = useStores();

		const isFree = ["Free"].includes(rate);

		const accessState = getShopGoodAccessState(shopGoodStore, authStore.userStore.active_shop_orders);

		console.log("GoodItem accessState", shopGoodStore.id, accessState.status);

		const { t } = useTranslation();

		const { id, payment_terms, is_popular, price_dollar, price_ruble, include_descriptions } = props;
		const price = settingsStore.lang === "ru" ? price_ruble : price_dollar;
		const navigate = useNavigate();

		const getPrice = () => {
			const locale = settingsStore.lang === "ru" ? "ru-RU" : "en-EN";

			let finalPrice = price;

			if (promoCodeStore.isActive && promoCodeStore.discount > 0) {
				finalPrice = price * (1 - promoCodeStore.discount / 100);
			}

			return new Intl.NumberFormat(locale, {
				minimumFractionDigits: 2,
				maximumFractionDigits: 2,
			}).format(finalPrice);
		};

		const handleOnBuy = async () => {
			if (!authStore.isAuth) {
				navigate("/sign/login");
				return;
			}

			if (rate.toLowerCase() === "free") {
				return;
			}

			if (settingsStore.lang !== "ru") {
				const sessionId = await stripeStore.checkoutSession({
					shop_good_id: id,
					promo_code: promoCodeStore.promoCode,
				});

				if (sessionId && stripeStore.instance) {
					await stripeStore.instance.redirectToCheckout({ sessionId });
				}

				return;
			}

			// Продамус
			const link = await API.request<string>(`shop/invoice`, {
				method: "POST",
				body: API.getFormData({
					shop_good_id: id,
					promo_code: promoCodeStore.promoCode,
				}),
			});

			// Открываем получаемую ссылку
			window.open(link, "_blank");
		};

		return (
			<GoodItemContainer isPopular={is_popular}>
				<GoodRate>{rate}</GoodRate>
				<GoodPrice>
					<GoodCurrency>{settingsStore.lang === "ru" ? "₽" : "$"}</GoodCurrency>
					{getPrice()}
				</GoodPrice>

				<GoodPriceDescription $paymentTerms={payment_terms}>{payment_terms}</GoodPriceDescription>

				<GoodDivider />

				<GoodList>
					{include_descriptions.map((include_description) => {
						return (
							<GoodListItem key={include_description.id}>
								<IconCheck />
								{include_description.descriptions}
							</GoodListItem>
						);
					})}
				</GoodList>

				{renderActionShopButton({
					accessState,
					isFree,
					t,
					onBuy: handleOnBuy,
					ButtonBuyComponent: ButtonBuy,
					PurchasedPlanBadgeComponent: PurchasedPlanBadge,
					PurchasedPlanDateComponent: PurchasedPlanDate,
				})}
			</GoodItemContainer>
		);
	},
);
